import { Colors } from '@amelio/ui-library';

import { InfoCallout as SharedInfoCallout } from '@/components/InfoCallout/InfoCallout';
import { useAmelioTranslations } from '@/hooks';

interface InfoCalloutProps {
    dataTestId?: string;
}

/** The evaluator-selection step's own wording on the shared informational callout. */
const InfoCallout = ({ dataTestId = 'info-callout' }: InfoCalloutProps) => {
    const { t } = useAmelioTranslations();

    return (
        <SharedInfoCallout
            title={t('cycleEvaluationSelectEvaluators.infoCallout.title')}
            description={t('cycleEvaluationSelectEvaluators.infoCallout.description')}
            tip={{
                label: t('cycleEvaluationSelectEvaluators.infoCallout.tipLabel'),
                description: t('cycleEvaluationSelectEvaluators.infoCallout.tipDescription'),
            }}
            titleWeight={'semibold'}
            bgColor={'bg-error-25'}
            borderColor={Colors.ERROR_50}
            borderRadius={'2xl'}
            iconColor={Colors.ERROR}
            iconSize={'sm'}
            iconWrapperClassName={
                'border-error-50 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border bg-white'
            }
            className={'mt-6 p-5'}
            dataTestId={dataTestId}
        />
    );
};

export { InfoCallout };
